import parkingBookingService from '@/api/parkingbooking'
import { PARKING_BOOKING } from '../types'
import Vue from 'vue'

const proto = Vue.prototype

export default {
  namespaced: true,
  state: {
    date: null,
    owners: [],
    parkings: [],
    parkingId: null,
    parkingQueryFilter: null,
    parkingSiteId: null,
    parkingVehicleId: null,
    loadedFirstTime: false,
    hasErrorValidation: false,
    startTime: null,
    endTime: null,
    currentDate: null,
    parkingsWihBookings: [],
    queryFilter: null,
    vehicles: []
  },
  getters:{
    date: (state) => {
      return state.date
    },
    currentDate: (state) => {
      return state.currentDate
    },
    fullDate: (state) => {
      const fullDate = Vue.prototype.$moment(state.date).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullDate
    },
    parkingSiteId: (state) => {
      return state.parkingSiteId
    },
    parkingVehicleId: (state) => {
      return state.parkingVehicleId
    },
    loadedFirstTime: (state) =>{
      return state.loadedFirstTime
    },
    hasErrorValidation: (state) =>{
      return state.hasErrorValidation
    },
    startTime: (state) => {
      return state.startTime
    },
    endTime: (state) => {
      return state.endTime
    },
    fullStartDate: (state) => {
      const start = state.date + ' ' + state.startTime
      const fullStartDate = proto.$moment(start).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullStartDate
    },
    fullEndDate: (state) => {
      const finish = state.date + ' ' + state.endTime
      const fullEndDate = proto.$moment(finish).utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z'
      return fullEndDate
    },
    queryFilter: (state) => {
      return state.queryFilter
    },
    parkingId: (state) => {
      return state.parkingId
    },
    parkingQueryFilter: (state) => {
      return state.parkingQueryFilter
    }
  },
  mutations: {
    [PARKING_BOOKING.SET_DATE] (state, date) {
      state.date = date
    },
    [PARKING_BOOKING.CURRENT_SET_DATE] (state, currentDate) {
      state.currentDate = currentDate
    },
    [PARKING_BOOKING.SELECT_OWNER] (state, item) {
      state.owners.splice(0, 1)
      state.owners.push(item)
    },
    [PARKING_BOOKING.REMOVE_OWNER] (state, index) {
      state.owners.splice(index, 1)
    },
    [PARKING_BOOKING.SET_PARKINGS] (state, parkings) {
      state.parkings = parkings
    },
    [PARKING_BOOKING.SET_PARKING_ID] (state, parkingId) {
      state.parkingId = parkingId
    },
    [PARKING_BOOKING.SET_SITE_ID] (state, siteId) {
      state.parkingSiteId = siteId
    },
    [PARKING_BOOKING.SET_VEHICLE_ID] (state, vehicleId) {
      state.parkingVehicleId = vehicleId
    },
    [PARKING_BOOKING.SET_LOADED_FIRST_TIME] (state, loadedFirstTime) {
      state.loadedFirstTime = loadedFirstTime
    },
    [PARKING_BOOKING.SET_HAS_ERROR_VALIDATION] (state, hasErrorValidation) {
      state.hasErrorValidation = hasErrorValidation
    },
    [PARKING_BOOKING.SET_START_TIME] (state, start) {
      state.startTime = start
    },
    [PARKING_BOOKING.SET_END_TIME] (state, end) {
      state.endTime = end
    },
    [PARKING_BOOKING.SET_FULL_START_DATE] (state, date) {
      state.fullStartDate = date
    },
    [PARKING_BOOKING.SET_FULL_END_DATE] (state, date) {
      state.fullEndDate = date
    },
    [PARKING_BOOKING.SET_PARKING_BOOKING] (state, parkingsWihBookings) {
      state.parkingsWihBookings = parkingsWihBookings
    },
    [PARKING_BOOKING.SET_QUERY_FILTER] (state, queryFilter) {
      state.queryFilter = queryFilter
    },
    [PARKING_BOOKING.SET_PARKING_QUERY_FILTER] (state, parkingQueryFilter) {
      state.parkingQueryFilter = parkingQueryFilter
    },
    [PARKING_BOOKING.SET_VEHICLES] (state, vehicles) {
      state.vehicles = vehicles
    },
  },
  actions: {
    setDate ({commit}, date) {
      commit(PARKING_BOOKING.SET_DATE, date)
    },
    setCurrentDate ({commit}, currentDate) {
      commit(PARKING_BOOKING.CURRENT_SET_DATE, currentDate)
    },
    selectOwner ({ commit, }, item) {
      let owner = item.email? {email: item.email, name: item.name} : {email: item}
      commit(PARKING_BOOKING.SELECT_OWNER, owner)
    },
    removeOwner ({ commit }, index) {
      commit(PARKING_BOOKING.REMOVE_OWNER, index)
    },
    setParkingId ({commit}, parkingId) {
      commit(PARKING_BOOKING.SET_PARKING_ID, parkingId)
    },
    setParkingSiteId ({commit}, siteId) {
      commit(PARKING_BOOKING.SET_SITE_ID, siteId)
    },
    setParkingVehicleId ({commit}, vehicleId) {
      commit(PARKING_BOOKING.SET_VEHICLE_ID, vehicleId)
    },
    setLoadedFirstTime ({commit}, loadedFirstTime) {
      commit(PARKING_BOOKING.SET_LOADED_FIRST_TIME, loadedFirstTime)
    },
    setHasErrorValidation ({commit}, hasErrorValidation) {
      commit(PARKING_BOOKING.SET_HAS_ERROR_VALIDATION, hasErrorValidation)
    },
    setStartTime ({commit}, start) {
      commit(PARKING_BOOKING.SET_START_TIME, start)
    },
    setEndTime ({commit}, end) {
      commit(PARKING_BOOKING.SET_END_TIME, end)
    },
    setFullStartDate ({commit}, fullStartDate) {
      commit(PARKING_BOOKING.SET_FULL_START_DATE, fullStartDate)
    },
    clearParkingsWithBookings ({commit}){
      commit(PARKING_BOOKING.SET_PARKING_BOOKING, [])
    },
    setQueryFilter ({commit}, queryFilter) {
      commit(PARKING_BOOKING.SET_QUERY_FILTER, queryFilter)
    },
    setParkingQueryFilter ({commit}, parkingQueryFilter) {
      commit(PARKING_BOOKING.SET_PARKING_QUERY_FILTER, parkingQueryFilter)
    },
    async getParkings ({dispatch, getters, commit, state}) {
      const userEmail = state.owners[0].email
      const start =  getters.fullStartDate
      const finish =  getters.fullEndDate
      try {
        let response = await parkingBookingService.getParkings(userEmail, start, finish, state.parkingSiteId)
        commit(PARKING_BOOKING.SET_PARKINGS, response.data)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveBookingOfAnUser ({dispatch, state, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const userEmail = state.owners[0].email
        const date =  getters.fullDate
        const parkingId = state.parkingId
        const start = getters.fullStartDate
        const finish = getters.fullEndDate
        const vehicleId = state.parkingVehicleId
        const body = {
          userEmail,
          date,
          parkingId,
          start,
          finish,
          vehicleId
        }
        await parkingBookingService.createBookingOfAnUser(state.parkingId, body)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async saveBooking ({dispatch, state, getters}) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        const userEmail = state.owners[0].email
        const date =  getters.fullDate
        const parkingId = state.parkingId
        const start = getters.fullStartDate
        const finish = getters.fullEndDate
        const vehicleId = state.parkingVehicleId
        const body = {
          userEmail,
          date,
          parkingId,
          start,
          finish,
          vehicleId
        }
        await parkingBookingService.createBooking(state.parkingId, body)
        dispatch('ParkingBooking/getAllParkingsWithTheirBookings', null, {root: true})
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async deleteParkingBooking ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await parkingBookingService.deleteParkingBooking(payload.parking.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    async deleteParkingBookingOfAnUser ({dispatch}, payload) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await parkingBookingService.deleteParkingBookingOfAnUser(payload.parking.id, payload.booking.id)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    markParkingBookingAsCheckedOut: function ({dispatch}, payload) {
      return new Promise((resolve, reject) => {
        parkingBookingService.markParkingBookingAsCheckedOut(payload.parking.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    markParkingBookingAsCheckedOutOfAnUser: function ({dispatch}, payload) {
      return new Promise((resolve, reject) => {
      parkingBookingService.markParkingBookingAsCheckedOutOfAnUser(payload.parking.id, payload.booking.id).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    markParkingBookingAsCheckedIn: function ({dispatch}, payload) {
      return new Promise((resolve, reject) => {
        parkingBookingService.markParkingBookingAsCheckedIn(payload.parkingId, payload.bookingId).then((response) => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        }).finally(
          dispatch('Global/hideLoading', null, {root: true})
        )
      })
    },
    getAllParkingsWithTheirBookings({ commit, state, dispatch }) {
      return new Promise((resolve) => {
          const date = proto.$moment(state.currentDate).utc().format()
          parkingBookingService.getAllParkingsWithTheirBookings(state.queryFilter, state.parkingQueryFilter, date).then((response) => {
              commit(PARKING_BOOKING.SET_PARKING_BOOKING, response.data)
              resolve()
          }).catch(() => {
              commit(PARKING_BOOKING.SET_PARKING_BOOKING, [])
          }).finally(
              dispatch('Global/hideLoading', null, { root: true })
          )
      })
    },
    async saveVehicleUser ({dispatch}, vehicle) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        await parkingBookingService.saveVehicleUser(vehicle)
        dispatch('Global/getInitialSettings', null, { root: true })
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    getPrimaryVehicleAnotherPerson({ dispatch }, userEmail) {
      return new Promise((resolve, reject) => {
        parkingBookingService.getPrimaryVehicleAnotherPerson(userEmail).then((response) => {
          dispatch('UserSettings/setVehicles', [response.data], {root: true})
          resolve()
        }).catch(() => {
          dispatch('UserSettings/setVehicles', [], {root: true})
          reject()
        }).finally(
          dispatch('Global/hideLoading', null, { root: true })
        )
      })
    },
    async getUserVehicles ({dispatch, commit, state}) {
      const userEmail = state.owners[0].email
      try {
        let response = await parkingBookingService.getUserVehicles(userEmail)
        commit(PARKING_BOOKING.SET_VEHICLES, response.data)
      }
      catch (error){
        return Promise.reject(error)
      }
      finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
    clearFilters: function ({commit}) {
      commit(PARKING_BOOKING.SET_QUERY_FILTER, null)
      commit(PARKING_BOOKING.SET_PARKING_QUERY_FILTER, null)
      commit(PARKING_BOOKING.SET_PARKING_BOOKING, null)
    }
  }
}
